module.exports = __webpack_public_path__ + "img/impact_bg3.fdda4f2e.jpg";